import React, { useEffect } from 'react';
import { Heading } from '../components/Heading/Heading';
import { Calendly } from '../components/Calendly/Calendly';
import { Container } from '../components/Container/Container';

const ScheduleAppointmentPage: React.FC = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div>
      <Container contentClassName="py-8 text-center flex-col" hasPadding>
        <Heading intent="h4" className="text-center hidden log:block" padding="noPadding">
          Schedule a Meeting
        </Heading>
        <Calendly />
      </Container>
    </div>
  );
};

export default ScheduleAppointmentPage;
